/* 
 * @author Tommy Brière
 * @copyright (c) 2015 Groupe PVP
 * @fileoverview TODO
 */
(function($g) {
    "use strict";
    var noop = function(){};
    
    function CreateJSPlayer(Sound) {
        //SoundPlayer.call(this);

        this.init = function (complete) {
            complete = complete || noop;
            var r = Sound.initializeDefaultPlugins();
            Sound.alternateExtensions = ["ogg"];
            complete(r);
        };

        this.play = function (item, options) {
            options=options||{};
            
            function sndComplete() {
                inst.off("complete", sndComplete);
                inst.off("interrupted", sndComplete);
                (options.complete || noop)(inst);
            }

            var inst = Sound.play(item.id, options);
            var state = inst.playState;
            if (state == Sound.PLAY_SUCCEEDED) {
                var oldStop = inst.stop;
                inst.stop = function () {//intercept stop
                    oldStop.call(inst);
                    sndComplete();
                };
                inst.on("complete", sndComplete);
                inst.on("interrupted", sndComplete);
                return inst;
            } else {
                $g.log("wrong sound state", item.id, state);
            }
        };

        this.setMuted = function (mute) {
            Sound.setMute(mute);
        };        
    }
    
    $g.CreateJSPlayer = CreateJSPlayer;
    
})(PVPGEngine);